var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankFindApiForDataMiners = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "205px",
    height: "161px",
    viewBox: "0 0 205 161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BFS_API_new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BFS_API_new",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud",
    transform: "translate(0.000000, 17.000000)",
    fill: "#003A5D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153,112.65 L153,101.18 L165.5,101.18 L167.23,101.18 L168.69,101.18 C169.975621,101.218546 171.261274,101.104415 172.52,100.84 C183.79,98.1 192.27,88.84 192.69,78.84 C193.16,67.76 185.85,58.1 174.5,54.84 C169.17,53.3 166.39,49.89 166.24,44.69 C166.186687,42.082854 165.878554,39.4871691 165.32,36.94 C162.289314,22.7206172 152.692583,14.5143495 136,11.9287478 L136,0.25099265 C136.457373,0.308068526 136.914078,0.371073906 137.37,0.44 C158.96,3.67 172.52,15.44 176.58,34.58 C177.236699,37.5922323 177.614959,40.6584802 177.71,43.74 C194.24,48.54 204.88,62.83 204.18,79.31 C203.55,94.31 191.37,108.06 175.18,111.99 C173.031048,112.471959 170.831904,112.693552 168.63,112.65 L167.01,112.65 L165.42,112.65 L153,112.65 Z M141,112.65 L132.64,112.65 L105,112.65 L105,101.18 L132.72,101.18 L141,101.18 L141,112.65 Z M124,0.149696312 L124,11.7962323 C115.02773,13.1573616 107.271533,18.0252841 100.89,26.4 C98.76,29.19 96.25,30.6 93.45,30.6 C91.5287437,30.5269676 89.6558353,29.9771229 88,29 C84.5713273,27.1012181 80.8465061,25.8289617 77,25.2285022 L77,13.5658974 C82.393908,14.1913061 87.6424624,15.8011449 92.48,18.33 C100.92685,7.7714371 111.703724,1.56072859 124,0.149696312 Z M65,13.8403551 L65,25.567359 C61.795572,26.2693693 58.7003269,27.4462177 55.82,29.07 C49.42,32.62 46.75,37.78 44.07,46.07 L43.94,46.5 C43.37,48.34 41.85,53.26 35.28,53.98 C21.22,55.53 11.43,66.26 12.49,78.98 C13.49,91.08 25.2,101.3 38.02,101.3 L38.59,101.3 C40.9874848,101.246017 43.4444632,101.200101 46,101.162572 L46,112.629044 C43.5013464,112.666524 41.1004106,112.713301 38.76,112.77 L38,112.8 C19.11,112.8 2.51,98.05 1,79.93 C-0.63,61.16 13.09,45.3 33,42.67 L33,42.58 C35.72,34.28 39.47,25 50.17,19 C54.788432,16.4155311 59.8101395,14.6750114 65,13.8403551 Z M58,101.052594 C59.9998488,101.044232 62.0723688,101.04 64.23,101.04 C70.65,101.04 77.04,101.04 83.35,101.11 L83.92,101.11 C86.9466667,101.129485 89.9733333,101.145015 93,101.15659 L93,112.632011 C89.9233333,112.620346 86.8466667,112.603009 83.77,112.58 L83,112.58 C76.76,112.58 70.43,112.51 64.07,112.51 C61.9684256,112.51 59.9489566,112.513649 58,112.521142 L58,101.052594 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "19.87 140.66 52.05 140.66 52.05 93.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "179.34 140.66 147.16 140.66 147.16 93.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.35,145.14 L99.35,97.79",
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "38.68 6.34 70.85 6.34 70.85 53.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#003A5D",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "161.87 6.34 129.69 6.34 129.69 53.54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 12.93,
    cy: 141.07,
    r: 5.93
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 186.28,
    cy: 141.07,
    r: 5.93
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 98.85,
    cy: 151.07,
    r: 5.93
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 31.74,
    cy: 5.93,
    r: 5.93
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#003A5D",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: 168.81,
    cy: 5.93,
    r: 5.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,93.69 C56.58,91.199196 54.560804,89.18 52.07,89.18 C49.579196,89.18 47.56,91.199196 47.56,93.69 C47.56,96.180804 49.579196,98.2 52.07,98.2 C54.558523,98.194501 56.5745,96.178523 56.58,93.69 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.67,93.69 C151.67,91.865875 150.571174,90.221366 148.885902,89.523303 C147.200631,88.825241 145.260799,89.211098 143.970948,90.500948 C142.681097,91.790799 142.295241,93.730631 142.993303,95.415902 C143.691366,97.101174 145.335875,98.2 147.16,98.2 C149.648523,98.194501 151.6645,96.178523 151.67,93.69 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero",
    points: "105.34 99.54 99.35 89.17 93.37 99.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.34,53.31 C66.335956,55.1399831 67.435733,56.7918369 69.125647,57.4940106 C70.81556,58.1961842 72.762115,57.8101082 74.056112,56.5161116 C75.350108,55.222115 75.736184,53.2755598 75.034011,51.5856466 C74.331837,49.8957334 72.679983,48.7959558 70.85,48.8 C68.361477,48.8054995 66.3455,50.8214773 66.34,53.31 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18,53.31 C125.18,55.8008042 127.199196,57.82 129.69,57.82 C132.180804,57.82 134.2,55.8008042 134.2,53.31 C134.2,50.8191958 132.180804,48.8 129.69,48.8 C127.201477,48.8054995 125.1855,50.8214773 125.18,53.31 Z",
    id: "Path",
    fill: "#003A5D",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankFindApiForDataMiners);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BankFind_APIForDataMiners.7ebf5f27ce361340bd4149ec3ae3ceb2.svg";